import { render, staticRenderFns } from "./winningBidCandidates.vue?vue&type=template&id=13785922&scoped=true"
import script from "./winningBidCandidates.vue?vue&type=script&lang=js"
export * from "./winningBidCandidates.vue?vue&type=script&lang=js"
import style0 from "./winningBidCandidates.vue?vue&type=style&index=0&id=13785922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13785922",
  null
  
)

export default component.exports